export const onEditDialogDone = entry => ({
  widget: 'entries',
  type: 'onEditDialogDone',
  payload: { entry },
})



// WEBPACK FOOTER //
// ./src/entries/actions/onEditDialogDone.js